import { useProjectedChart, useTheme } from "@hooks";
import { constants, spacing } from "@layout";
import { CSSProperties } from "react";

export const useStyles = () => {
  const { invertedTheme } = useProjectedChart();

  const { theme } = useTheme();

  const chartTheme = theme.chart.projection;

  const styles: Record<string, CSSProperties> = {
    container: {
      alignItems: "center",
      justifyContent: "space-around",
    },
    text: {
      color: invertedTheme ? chartTheme.inverted.text : chartTheme.default.text,
      marginLeft: spacing.xs,
      marginTop: 1,
    },
    circle: {
      backgroundColor: "red",
      borderRadius: constants.radius.button,
      width: 8,
      height: 8,
    },
  };

  return styles;
};
